<template>
  <div></div>
</template>

<script>
import * as THREE from 'three'
/* eslint-disable */
import 'imports-loader?THREE=three!three/examples/js/loaders/OBJLoader.js'
import 'imports-loader?THREE=three!./fresnel.js'

import 'imports-loader?THREE=three!three/examples/js/postprocessing/EffectComposer.js'
import 'imports-loader?THREE=three!three/examples/js/postprocessing/RenderPass.js'
import 'imports-loader?THREE=three!three/examples/js/postprocessing/MaskPass.js'
import 'imports-loader?THREE=three!three/examples/js/postprocessing/ShaderPass.js'
import 'imports-loader?THREE=three!three/examples/js/shaders/CopyShader.js'
import 'imports-loader?THREE=three!three/examples/js/shaders/FXAAShader.js'
import 'imports-loader?THREE=three!three/examples/js/shaders/ConvolutionShader.js'
import 'imports-loader?THREE=three!three/examples/js/shaders/LuminosityHighPassShader.js'
import 'imports-loader?THREE=three!three/examples/js/postprocessing/UnrealBloomPass.js'
/* eslint-enable */

import * as Remixer from '@/components/Pages/KeyRemixer/remixer.js'

/* eslint-disable */
function runner ({ scene, renderer,  self }) {
  // custom global variables
  var mirrorKey, mirrorKeyCamera; // for mirror material
  var mirrorSphere, mirrorSphereCamera; // for mirror material
  var floor, floor1, floor2, floor3, floor15, floor25;

  let api = {}

  var box3dGroup = new THREE.Object3D()
  // box3dGroup.rotation.z = Math.PI * -0.23

  let cfg = {
    now: 'b4',
    b1: {
      f1: require('./cdp/amy3.jpg'),
      f2: require('./cdp/amy2.jpg'),
      f3: require('./cdp/sky-edit.jpg'),
      f4: require('./cdp/sky-edit.jpg'),
      f5: require('./cdp/sky-edit.jpg'),
      f6: require('./cdp/sky-edit.jpg'),
      f7: require('./cdp/amy3.jpg')
    },
    b2: {
      f1: require('./cdp2/waterdudv.jpg'),
      f2: require('./cdp/amy2.jpg'),
      f3: require('./cdp/amy2.jpg'),
      f4: require('./cdp/waterdudv2.jpg'),
      f5: require('./cdp/sky-2.jpg'),
      f6: require('./cdp/sky-2.jpg'),
      f7: require('./cdp/amy3.jpg')
    },
    b3: {
      f1: require('./cdp2/amy6.jpg'),
      f2: require('./cdp/sky-2.jpg'),
      f3: require('./cdp2/amy6.jpg'),
      f4: require('./cdp2/waterdudv.jpg'),
      f5: require('./cdp2/waterdudv.jpg'),
      f6: require('./cdp2/amy6.jpg'),
      f7: require('./cdp/waterdudv.jpg')
    },
    b4: {
      f1: require('./cdp3/amy6.jpg'),
      f2: require('./cdp3/sky-r1.jpg'),
      f3: require('./cdp3/amy6.jpg'),
      f4: require('./cdp3/waterdudv.jpg'),
      f5: require('./cdp3/waterdudv.jpg'),
      f6: require('./cdp3/amy6.jpg'),
      f7: require('./cdp3/waterdudv.jpg')
    },
    b5: {
      f1: require('./cdp3/amy6.jpg'),
      f2: require('./cdp3/sky-r1.jpg'),
      f3: require('./cdp3/amy6.jpg'),
      f4: require('./cdp3/waterdudv.jpg'),
      f5: require('./cdp3/waterdudv.jpg'),
      f6: require('./cdp3/amy6.jpg'),
      f7: require('./cdp3/waterdudv.jpg')
    }
  }

  // FLOOR
	// var floorTexture = new THREE.ImageUtils.loadTexture( require('./cdp/white.jpg') );
	// var floorTexture = new THREE.ImageUtils.loadTexture( require('./cdp2/waterdudv.jpg') );
	// var floorTexture = new THREE.ImageUtils.loadTexture( require('./cdp/amy3.jpg') );
	// var floorTexture = new THREE.ImageUtils.loadTexture( require('./cdp/amy3.jpg') );
	var floorTexture = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f1 );
	floorTexture.wrapS = floorTexture.wrapT = THREE.RepeatWrapping;
	floorTexture.repeat.set( 1, 1 );
	var floorMaterial = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture, side:THREE.BackSide } );
	var floorGeometry = new THREE.PlaneGeometry(1000, 1000);
	floor = new THREE.Mesh(floorGeometry, floorMaterial);
  floor.position.y = -300;
  floor.rotation.x = Math.PI / 2;
  floor.visible = false
	box3dGroup.add(floor);

	// Back
	// var floorTexture1 = new THREE.ImageUtils.loadTexture( require('./cdp/amy2.jpg') );
	// var floorTexture1 = new THREE.ImageUtils.loadTexture( require('./cdp/amy2.jpg') );
	// var floorTexture1 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-1.jpg') );
	var floorTexture1 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f2 );
	floorTexture1.wrapS = floorTexture1.wrapT = THREE.RepeatWrapping;
	floorTexture1.repeat.set( 1, 1 );
	var floorMaterial1 = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture1, side:THREE.DoubleSide } );
	var floorGeometry1 = new THREE.PlaneGeometry(1000, 1000);
	floor1 = new THREE.Mesh(floorGeometry1, floorMaterial1);
	floor1.position.z = -500;
  floor1.rotation.z = -Math.PI / 2;
  floor1.visible = false
	box3dGroup.add(floor1);

	// ME
	// var floorTexture15 = new THREE.ImageUtils.loadTexture( require('./cdp/amy3.jpg') );
	// var floorTexture15 = new THREE.ImageUtils.loadTexture( require('./cdp/amy2.jpg') );
	// var floorTexture15 = new THREE.ImageUtils.loadTexture( require('./cdp2/lok.jpg') );
	// var floorTexture15 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
	var floorTexture15 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f3 );
	floorTexture15.wrapS = floorTexture15.wrapT = THREE.RepeatWrapping;
	floorTexture15.repeat.set( 1, 1 );
	var floorMaterial15 = new THREE.MeshBasicMaterial( { color: 0xfefcff, transparent: true, opacity: 1.0, map: floorTexture15, side:THREE.DoubleSide } );
	var floorGeometry15 = new THREE.PlaneGeometry(1000, 1000);
	floor15 = new THREE.Mesh(floorGeometry15, floorMaterial15);
	floor15.position.z = 500;
	floor15.rotation.z = -Math.PI / 2;
  floor15.visible = false
	box3dGroup.add(floor15);

	// Left
	// var floorTexture2 = new THREE.ImageUtils.loadTexture( require('./cdp2/waterdudv.jpg') );
	// var floorTexture2 = new THREE.ImageUtils.loadTexture( require('./cdp/waterdudv2.jpg') );
	// var floorTexture2 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-2.jpg') );
	// var floorTexture2 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
	var floorTexture2 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f4 );
	floorTexture2.wrapS = floorTexture2.wrapT = THREE.RepeatWrapping;
	floorTexture2.repeat.set( 1, 1 );
	var floorMaterial2 = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture2, side:THREE.DoubleSide } );
	var floorGeometry2 = new THREE.PlaneGeometry(1000, 1000);
	floor2 = new THREE.Mesh(floorGeometry2, floorMaterial2);
	floor2.position.x = -500;
	floor2.rotation.y = -Math.PI / 2;
	floor2.visible = false
	box3dGroup.add(floor2);

	// Left close
	// var floorTexture25 = new THREE.ImageUtils.loadTexture( require('./cdp2/sky-r1.jpg') );
	// var floorTexture25 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
	// var floorTexture25 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-2.jpg') );
	// var floorTexture25 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
	var floorTexture25 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f5 );
	floorTexture25.wrapS = floorTexture25.wrapT = THREE.RepeatWrapping;
	floorTexture25.repeat.set( 1, 1 );
	var floorMaterial25 = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture25, side:THREE.DoubleSide } );
	var floorGeometry25 = new THREE.PlaneGeometry(100, 100);
	floor25 = new THREE.Mesh(floorGeometry25, floorMaterial25);
	floor25.position.x = -100;
	floor25.rotation.y = -Math.PI / 2;
	floor25.visible = false
  box3dGroup.add(floor25);



	// Right
	// var floorTexture3 = new THREE.ImageUtils.loadTexture( require('./cdp2/sky-r1.jpg') );
	// var floorTexture3 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
	// var floorTexture3 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-2.jpg') );
	// var floorTexture3 = new THREE.ImageUtils.loadTexture( require('./cdp/sky-edit.jpg') );
	var floorTexture3 = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f6 );
	floorTexture3.wrapS = floorTexture3.wrapT = THREE.RepeatWrapping;
	floorTexture3.repeat.set( 1, 1 );
	var floorMaterial3 = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture3, side:THREE.DoubleSide } );
	var floorGeometry3 = new THREE.PlaneGeometry(1000, 1000);
	floor3 = new THREE.Mesh(floorGeometry3, floorMaterial3);
	floor3.position.x = 500;
	floor3.rotation.y = -Math.PI / 2;
  floor3.visible = false
	box3dGroup.add(floor3);


  //7th
  var floorTexture = new THREE.ImageUtils.loadTexture( cfg[cfg.now].f7 );
	floorTexture.wrapS = floorTexture.wrapT = THREE.RepeatWrapping;
	floorTexture.repeat.set( 1, 1 );
	var floorMaterial = new THREE.MeshBasicMaterial( { color: 0xffffff, transparent: true, opacity: 1.0, map: floorTexture, side:THREE.BackSide } );
	var floorGeometry = new THREE.PlaneGeometry(500, 500);
	var floor7 = new THREE.Mesh(floorGeometry, floorMaterial);
  floor7.position.y = -200;
  floor7.rotation.x = Math.PI / 2;
  floor7.visible = false
	box3dGroup.add(floor7);

  scene.add(box3dGroup);

  let cache = {}

  api.changeColor = ({ color1, color2, color3, color4, color5, color6, color7, texture, texture2, texture3, texture4, texture5, texture6, texture7 }) => {
    if(floor && cache.color1 !== color1) floor.material.color = new THREE.Color(color1);
    if(floor1 && cache.color2 !== color2) floor1.material.color = new THREE.Color(color2);
    if(floor15 && cache.color3 !== color3) floor15.material.color = new THREE.Color(color3);
    if(floor2 && cache.color4 !== color4) floor2.material.color = new THREE.Color(color4);
    if(floor25 && cache.color5 !== color5) floor25.material.color = new THREE.Color(color5);
    if(floor3 && cache.color6 !== color6) floor3.material.color = new THREE.Color(color6);

    if(texture && cache.texture !== texture) floor.material.map = new THREE.TextureLoader().load(texture)
    if(texture2 && cache.texture2 !== texture2) floor1.material.map = new THREE.TextureLoader().load(texture2)
    if(texture3 && cache.texture3 !== texture3) floor15.material.map = new THREE.TextureLoader().load(texture3)
    if(texture4 && cache.texture4 !== texture4) floor2.material.map = new THREE.TextureLoader().load(texture4)
    if(texture5 && cache.texture5 !== texture5) floor25.material.map = new THREE.TextureLoader().load(texture5)
    if(texture6 && cache.texture6 !== texture6) floor3.material.map = new THREE.TextureLoader().load(texture6)

    cache.texture = texture
    cache.texture2 = texture2
    cache.texture3 = texture3
    cache.texture4 = texture4
    cache.texture5 = texture5
    cache.texture6 = texture6
    cache.texture7 = texture7


    cache.color1 = color1
    cache.color2 = color2
    cache.color3 = color3
    cache.color4 = color4
    cache.color5 = color5
    cache.color6 = color6
    cache.color7 = color7
  }

  api.clean = () => {}
  // ================BLOOM============
  let rtParameters = {
    minFilter: THREE.LinearFilter,
    magFilter: THREE.LinearFilter,
    format: THREE.RGBFormat,
    stencilBuffer: true
  }
  let dpi = window.devicePixelRatio || 1.0
  let composer = new THREE.EffectComposer(self.renderer, new THREE.WebGLRenderTarget( window.innerWidth, window.innerHeight, rtParameters ))
  composer.setSize(window.innerWidth * dpi, window.innerHeight * dpi);
  window.addEventListener('resize', () => {
    composer.setSize(window.innerWidth * dpi, window.innerHeight * dpi);
  }, false)

  let effectFXAA = new THREE.ShaderPass( THREE.FXAAShader );
  effectFXAA.uniforms[ 'resolution' ].value.set( 1 / window.innerWidth, 1 / window.innerHeight );
  effectFXAA.renderToScreen = true

  var effectCopy = new THREE.ShaderPass(THREE.CopyShader)
  effectCopy.renderToScreen = true

  let renderBG = new THREE.RenderPass(self.scene, self.camera)
  // let renderModel = new THREE.RenderPass(myKeyScene, self.camera)

  // var clearMask = new THREE.ClearMaskPass()
  // var renderMask = new THREE.MaskPass(myKeyScene, self.camera)
  let bloomPass = new THREE.UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 ); //1.0, 9, 0.5, 512);
  // bloomPass.renderToScreen = true;
  self.remixBloom = ({ exposure, threshold, strength, radius }) => {
    bloomPass.threshold = Number(threshold)
    bloomPass.strength = Number(strength)
    bloomPass.radius = Number(radius)
  }

  bloomPass.threshold = Number(self.RS.bloom.threshold)
  bloomPass.strength = Number(self.RS.bloom.strength)
  bloomPass.radius = Number(self.RS.bloom.radius)

  // composer.addPass( renderBG );
  // composer.addPass( renderMask );
  // composer.addPass( renderModel );
  // composer.addPass( clearMask );
  // composer.addPass( renderModel );
  // composer.addPass( bloomPass );

  /*
  composer4.addPass( renderScene );
  composer4.addPass( renderMask );
  composer4.addPass( effectDotScreen );
  composer4.addPass( clearMask );
  composer4.addPass( effectCopy );
  */
  composer.addPass( renderBG );
  // composer.addPass( renderMask );
  if (self.hasPerf) {
    composer.addPass( bloomPass );
  } else {
    console.log('avoiding bloom pass');
  }
  // composer.addPass( clearMask );


  composer.addPass( effectCopy );


  //======== key ========
  var group = new THREE.Object3D();
  self.group = group
  let cylinder
  var manager = new THREE.LoadingManager();
	var loader = new THREE.OBJLoader(manager);
	loader.load(require('./cdp/key1.obj'), function(object){
		var shader = THREE.FresnelShader;
		mirrorKey = object.children[0];
		mirrorKeyCamera = new THREE.CubeCamera( 0.1, 5000, 512 );
		scene.add( mirrorKeyCamera );
		var uniforms = THREE.UniformsUtils.clone( shader.uniforms );
		uniforms[ "tCube" ].value = mirrorKeyCamera.renderTarget;
		var mirrorKeyMaterial = new THREE.MeshBasicMaterial( {
      transparent: true,
      opacity: 1.0,
      fragmentShader: shader.fragmentShader,
			vertexShader: shader.vertexShader,
			// uniforms: uniforms,
			envMap: mirrorKeyCamera.renderTarget
		} );
		mirrorKey.material = mirrorKeyMaterial;
		// mirrorKey.position.set(0,0,0);

    group.add(mirrorKey);

    group.scale.x = 5.0
    group.scale.y = 5.0
    group.scale.z = 5.0

    mirrorKey.geometry.computeBoundingSphere()
    mirrorKey.geometry.computeBoundingBox()

    var customMaterialAtmosphere = new THREE.ShaderMaterial( {
        uniforms:
      {
        // "c":   { type: "f", value: 0.1 },
        // "p":   { type: "f", value: 4 },
        "c":   { type: "f", value: 0.1 },
        "p":   { type: "f", value: 4.0 },
        opacity: { value: 1.0 }
      },
      transparent: true,
      depthWrite: false,
      vertexShader:   require('./WoozyShaders/AlexGlow.vert'),
      fragmentShader: require('./WoozyShaders/AlexGlow.frag')
    }   );

    var sphereGeo = new THREE.CylinderGeometry( 1.9, 1.9, 46.5, 32 );
    cylinder = new THREE.Mesh( sphereGeo, customMaterialAtmosphere );
    cylinder.position.set(0,-1.6,-1);
    // cylinder.position.set(0,-1.6,-1);
    // cylinder.scale.x = 5;
    // cylinder.scale.y = 4.79;
    // cylinder.scale.z = 4;

    cylinder.position.copy(mirrorKey.position);
    cylinder.scale.x = 1.1
    cylinder.scale.z = 1.1
    // cylinder.position.y += -1.6 * 5;
    // cylinder.position.z += -1 * 5;

    cylinder.material.side = THREE.BackSide;
    group.add(cylinder);

    // scene.add(cylinder);



    // api.key = mirrorKey
    self.key = mirrorKey
    self.cylinder = cylinder
    self.group = group
    self.$emit('element', self)
    // self.$parent.$emit('add', mirrorKey)
    self.$parent.$emit('add', group)
    // self.$parent.$emit('add', light)
    api.clean = () => {
      // self.$parent.$emit('remove', mirrorKey)
      self.$parent.$emit('remove', group)
      // self.$parent.$emit('remove', light)
    }
    // scene.add(mirrorKey);
  });

  // let runrun = ({ wrapper, visible }) => {
  //   if (key && key.material.uniforms) {
  //     key.material.uniforms.time.value = window.performance.now() / 1000
  //   }

  //   uniforms2['time'].value += 0.01

  //   uniforms2['viewVector'].value.x = key.position.x
  //   uniforms2['viewVector'].value.y = key.position.y
  //   uniforms2['viewVector'].value.z = key.position.z

  //   key.visible = false
  //   wrapper.scale.x = -1

  //   // this.cubeCamera.position.z = this.refractionBoxAlpha.parent.position.z
  //   cubeCamera.position.x = key.position.x
  //   cubeCamera.position.y = key.position.y
  //   cubeCamera.position.z = key.position.z

  //   cubeCamera.update(this.renderer, this.scene)
  //   wrapper.scale.x = 1
  //   // this.refractionBoxAlpha.visible = true
  //   key.visible = visible
  // }

  // setInterval(() => {
  //   floor.visible = true
  //   setTimeout(() => {
  //     floor.visible = false
  //   },500)
  // }, 1000)



  self.runrun = api.run = ({ wrapper, visible }) => {
    // // if(floor) floor.visible = true;
    // if(floor1) floor1.visible = true;
    // if(floor15) floor15.visible = true;
    // if(floor2) floor2.visible = true;
    // if(floor25) floor25.visible = false;
    // if(floor3) floor3.visible = true;

    if (floor7) {
      floor7.visible = true
      floor7.rotation.z += 0.03
    }

    box3dGroup.rotation.y += 0.02

    if (mirrorKey) {
      mirrorKey.rotation.y += 0.01
    }

    if (!(self.$route.path === '/demo/remixer2' || self.$route.path === '/demo/remixer')) {
      if(floor) floor.visible = true;
      if(floor1) floor1.visible = true;
      if(floor15) floor15.visible = true;
      if(floor2) floor2.visible = true;
      if(floor25) floor25.visible = true;
      if(floor3) floor3.visible = true;
      if(floor7) floor7.visible = true;
    } else {
      if(floor) floor.visible = self.RS.visible1;
      if(floor1) floor1.visible = self.RS.visible2;
      if(floor15) floor15.visible = self.RS.visible3;
      if(floor2) floor2.visible = self.RS.visible4;
      if(floor25) floor25.visible = self.RS.visible5;
      if(floor3) floor3.visible = self.RS.visible6;
      if(floor7) floor7.visible = self.RS.visible7;
    }

    if(floor) floor.material.opacity = self.RS.opacity1;
    if(floor1) floor1.material.opacity = self.RS.opacity2;
    if(floor15) floor15.material.opacity = self.RS.opacity3;
    if(floor2) floor2.material.opacity = self.RS.opacity4;
    if(floor25) floor25.material.opacity = self.RS.opacity5;
    if(floor3) floor3.material.opacity = self.RS.opacity6;
    if(floor7) floor7.material.opacity = self.RS.opacity7;

    if (mirrorKey && cylinder) {
      cylinder.visible = false;
      mirrorKey.visible = false;
      mirrorKeyCamera.update( renderer, scene );
      mirrorKey.visible = visible;
      group.visible = visible;
      cylinder.visible = visible;
      cylinder.visible = false;
      // mirrorKey.rotation.y += 0.01;

      mirrorKeyCamera.position.x = mirrorKey.position.x;
      mirrorKeyCamera.position.y = mirrorKey.position.y;
      mirrorKeyCamera.position.z = mirrorKey.position.z;
    }

    if (!(self.$route.path === '/demo/remixer2' || self.$route.path === '/demo/remixer')) {
      if(floor) floor.visible = false;
      if(floor1) floor1.visible = false;
      if(floor15) floor15.visible = false;
      if(floor2) floor2.visible = false;
      if(floor25) floor25.visible = false;
      if(floor3) floor3.visible = false;
      if(floor7) floor7.visible = false;
    } else {
      if(floor) floor.visible = self.RS.afterVisible1;
      if(floor1) floor1.visible = self.RS.afterVisible2;
      if(floor15) floor15.visible = self.RS.afterVisible3;
      if(floor2) floor2.visible = self.RS.afterVisible4;
      if(floor25) floor25.visible = self.RS.afterVisible5;
      if(floor3) floor3.visible = self.RS.afterVisible6;
      if(floor7) floor7.visible = self.RS.afterVisible7;
    }

    // if(floor) floor.visible = false;
    // if(floor1) floor1.visible = false;
    // if(floor15) floor15.visible = false;
    // if(floor2) floor2.visible = false;
    // if(floor25) floor25.visible = false;
    // if(floor3) floor3.visible = false;

    // if (floor7) floor7.visible = false

    // renderer.render( scene, camera );

    composer.render()
  }

  return api
}
/* eslint-enable */

export default {
  props: {
    bg: {},
    camera: {},
    renderer: {},
    useFresnel: {},
    scene: {},
    texture: {},
    hasPerf: {
      default: true
    },
    viewBG: {
      default: false
    }
  },
  data () {
    return {
      Remixer,
      RS: Remixer.state,
      clean () {}
    }
  },
  watch: {
    bloomJSON () {
      if (this.remixBloom) {
        console.log('test')
        this.remixBloom(this.RS.bloom)
      }
    },
    colorChange () {
      if (this.api) {
        this.api.changeColor(this.RS)
      }
    }
  },
  computed: {
    bloomJSON () {
      return JSON.stringify(this.RS.bloom)
    },
    colorChange () {
      return JSON.stringify(this.RS)
    }
  },
  mounted () {
    // let rAFID = 0
    var api = this.api = runner({
      scene: this.scene,
      renderer: this.renderer,
      self: this
    })

    // var rAF = () => {
    //   api.run()
    //   window.requestAnimationFrame(rAF)
    // }
    // window.requestAnimationFrame(rAF)

    this.clean = () => {
      api.clean()
      // window.cancelAnimationFrame(rAFID)
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Parts/Key3D/Key3D-v2-Bloom.vue